export const ENTERPRISE_ADMIN_COACH_MODE_ID = 'ENTERPRISE_ADMIN';
